// src/utils/wizardDraft.js
//
// The 7-step Cost Estimation wizard persists its in-progress data to
// localStorage between steps (each step is its own route/page, so this is
// how data survives navigating from Step1 -> Step2 -> ... -> Step5 /
// Basis of Cost / Element Scope). That's necessary for editing an existing
// project (ProjectList.jsx's "Edit" deliberately pre-fills these same keys
// with the row's real saved data) and for resuming a draft mid-flow.
//
// The bug this file fixes: starting a brand-new estimation only ever
// cleared the "step1" key (see ProjectList.jsx's old handleEstimateCost),
// so Step1 came up blank but every other step (Budget Amount, Asset
// Selection, Basis of Cost, the final summary) still read whatever the
// PREVIOUS estimation had left behind in localStorage -- old budget
// figures, old selected assets, etc. quietly reappearing on a "new" one.
//
// clearWizardDraft() is the single source of truth for every localStorage
// key any wizard step reads or writes (cross-checked against Step1-5,
// BasisOfCost, and ElementScopePage1 as of this fix -- see each file's own
// localStorage calls if a future step adds a new key, and add it here
// too). Call it right before navigating to /cost-estimation-step1 from
// any "start a NEW estimation" entry point -- NOT from mid-wizard
// Back/Next buttons, and NOT from the "Edit" flow, which intentionally
// overwrites these same keys with the project being edited.
export function clearWizardDraft() {
  const keys = [
    // Step1ProjectInfo.jsx
    "step1",
    "projectID",
    "projectName",
    "estimatedBy",
    "estimationDate",
    "operatingCompany",
    "intro",
    "inflation",
    "financial",
    "contingency",
    "risks",
    "opportunities",
    "class",
    "C_ID",
    "project_db_id",
    // Step2RiskInflation.jsx (Budget Amount)
    "step2Values",
    // Step3AssetSelection.jsx
    "step3",
    // Step4SubElement.jsx / Step5Final.jsx
    "step5TotalCost",
    "step5_snapshot",
    "step5",
    "step5_final_saved",
    // defensive: alias keys Step5Final.jsx's read-side fallback checks for
    // but nothing currently writes to -- harmless to clear if unused.
    "step5_total",
    "step5Total",
    "step5TotalCostValue",
    // BasisOfCost.jsx
    "basis_of_cost_draft",
  ];

  keys.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      // localStorage can throw in rare browser lockdown modes -- clearing
      // stale drafts is best-effort, not worth crashing navigation over.
    }
  });
}
